import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultPhraseInfo } from '../interfaces/PhraseIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C307PhraseUpdateProps {
  execPhraseUpdate: (
    deviceId: string,
    old_phraseText: string,
    phraseText: string,
    language?: string,
  ) => Promise<ResultPhraseInfo>
  loading: loadStatus
}

// C307 優先単語更新API呼出
export const useC307PhraseUpdate = (): C307PhraseUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execPhraseUpdate = async (
    deviceId: string,
    old_phraseText: string,
    phraseText: string,
    language = 'ja',
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      // ヘッダ作成
      const headers = {
        ...axiosDefaultHeader,
        Authorization: `Bearer ${jwt}`,
      }

      // ボディ作成
      const body = {
        old_phrase_text: old_phraseText,
        phrase_text: phraseText,
        language,
      }

      const response = await axios.put(
        buildDeviceUrl(deviceId, apiUrl.phrasesPath),
        body,
        {
          headers,
          validateStatus: () => true,
        },
      )

      setLoading(loadStatus.LOADED)
      if (response.status === apiStatus.SUCCESS) {
        return { success: true, info: response.data }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execPhraseUpdate, loading }
}